import {
  BURGLARY,
  SILENT_ALARM,
  HOLDUP,
  OTHER,
  MOBILE_PANIC,
  CRASH,
  TRAIN_DERAILMENT,
  ACTIVE_ASSAILANT,
  MEDICAL,
  CO,
  FIRE,
  CALL_TO_EMERGENCY_NUMBER,
  CORPORATE_CALL_TO_EMERGENCY_NUMBER,
  EXECUTIVE_CALL_TO_EMERGENCY_NUMBER,
  RAIL_FIRE,
  HAZMAT_RELEASE,
  NO_INCIDENT,
} from '@rsos/base-constants/alertEmergencyTypes';
import {
  ACTIVE_ASSAILANT_ALERT_TYPE,
  LAW_ENFORCEMENT_ALERT_TYPE,
  FIRE_ALERT_TYPE,
  MEDICAL_ALERT_TYPE,
  TRAIN_INCIDENT_ALERT_TYPE,
  TEST_MODE_ALERT_TYPE,
  INCIDENT_MANAGEMENT_TYPE,
} from '@rsos/base-constants/alertTypes';

/** There are over 5 alert types and over 20 emergency types that are clustered under those alert types */

/**
 * supply an emergency type and return which alert type it belongs to
 * @param {String} emergencyType - emergency type name
 * @returns String
 */

const mapEmergencyTypeToAlertType = (emergencyType = '') => {
  if (
    [BURGLARY, SILENT_ALARM, HOLDUP, OTHER, MOBILE_PANIC, CRASH].includes(
      emergencyType,
    )
  ) {
    return LAW_ENFORCEMENT_ALERT_TYPE;
  } else if ([FIRE, CO].includes(emergencyType)) {
    return FIRE_ALERT_TYPE;
  } else if ([ACTIVE_ASSAILANT].includes(emergencyType)) {
    return ACTIVE_ASSAILANT_ALERT_TYPE;
  } else if (
    [TRAIN_DERAILMENT, RAIL_FIRE, HAZMAT_RELEASE, NO_INCIDENT].includes(
      emergencyType,
    )
  ) {
    return TRAIN_INCIDENT_ALERT_TYPE;
  } else if (emergencyType.startsWith('TEST')) {
    return TEST_MODE_ALERT_TYPE;
  } else if ([MEDICAL].includes(emergencyType)) {
    return MEDICAL_ALERT_TYPE;
  } else if (
    [
      CALL_TO_EMERGENCY_NUMBER,
      CORPORATE_CALL_TO_EMERGENCY_NUMBER,
      EXECUTIVE_CALL_TO_EMERGENCY_NUMBER,
    ].includes(emergencyType)
  ) {
    return INCIDENT_MANAGEMENT_TYPE;
  }
  return '';
};

export default mapEmergencyTypeToAlertType;
